import React from 'react';
import '../index.css';

const SERVICES = [
  {
    icon: '☁️',
    name: 'Clumsy Cloud',
    desc: 'Personal cloud storage and file management.',
    href: 'https://cloud.stayclumsy.com',
  },
  {
    icon: '🎬',
    name: 'Clumsy Movie',
    desc: 'Stream your personal movie library.',
    href: 'https://movie.stayclumsy.com',
  },
  {
    icon: '🔍',
    name: 'Movie Finder',
    desc: 'Discover and track movies you want to watch.',
    href: 'https://findmovies.stayclumsy.com',
  },
  {
    icon: '📡',
    name: 'Server Status',
    desc: 'Live uptime and health for all services.',
    href: 'https://status.stayclumsy.com/',
  },
];

const Home = () => (
  <>
    <section className="hero">
      <h1 className="hero-title">Stay Clumsy</h1>
      <p className="hero-sub">A personal hub for cloud, media, and tools.</p>
    </section>

    <section className="services">
      <div className="services-grid">
        {SERVICES.map(({ icon, name, desc, href }) => (
          <a
            key={href}
            className="service-card"
            href={href}
            target="_blank"
            rel="noreferrer"
          >
            <span className="service-icon">{icon}</span>
            <span className="service-name">{name}</span>
            <span className="service-desc">{desc}</span>
            <span className="service-link">Open &rarr;</span>
          </a>
        ))}
      </div>
    </section>
  </>
);

export default Home;
